import Vue from 'vue'
import store from '@/store/index'

// carga de imagen de fondo
// parámetros
// image -> imagen de fondo
// alternative -> determina si cargamos imágen alternativa (fondo app)
// dir -> determina la dirección del degradado (to left, to right,  )
Vue.directive('bg', {
  inserted: function (el, binding) {
    // blur
    if (store.getters.getData.is_background_blur) el.classList.add('bg-blur')

    // background image
    let src = ''
    if (binding.value.image) {
      src = binding.value.image
    } else if (binding.value.alternative && store.getters.getData.background) {
      src = store.getters.getData.background
    }

    if (src) {
      let loaded = () => {
        if (binding.value.dir) {
          el.style.backgroundImage = 'linear-gradient(' + binding.value.dir + ', rgba(0, 0, 0, .9), rgba(0, 0, 0, 0)) , url("' + src + '")'
        } else {
          el.style.backgroundImage = 'url("' + src + '")'
        }
      }
      let bgImg = new Image()
      bgImg.onload = loaded
      bgImg.src = src
    }
  },
  update (el, binding) {
    // background image
    let src = ''
    if (binding.value.image) {
      src = binding.value.image
    } else if (binding.value.alternative && store.getters.getData.background) {
      src = store.getters.getData.background
    }

    if (src) {
      let loaded = () => {
        if (binding.value.dir) {
          el.style.backgroundImage = 'linear-gradient(' + binding.value.dir + ', rgba(0, 0, 0, .9), rgba(0, 0, 0, 0)) , url("' + src + '")'
        } else {
          el.style.backgroundImage = 'url("' + src + '")'
        }
      }
      let bgImg = new Image()
      bgImg.onload = loaded
      bgImg.src = src
    }
  }
})

// carga imagen en listas
function success (el, img) {
  el.style.backgroundImage = 'url("' + img + '")'
  el.classList.remove('lazy-load-error')
  el.classList.remove('lazy-load-progress')
  el.classList.add('lazy-load-success')
}

function loading (el) {
  el.classList.remove('lazy-load-error')
  el.classList.remove('lazy-load-success')
  el.classList.add('lazy-load-progress')
}

function failure (el) {
  el.classList.remove('lazy-load-success')
  el.classList.remove('lazy-load-progress')
  el.classList.add('lazy-load-error')
}

Vue.directive('lazy-load-img', (el, binding, vnode) => {
  loading(el)
  let bgMedium = new Image()
  bgMedium.onload = () => { success(el, binding.value.image) }
  bgMedium.onerror = () => {
    let bgImage = new Image()
    bgImage.onload = () => { success(el, binding.value.image) }
    bgImage.onerror = () => { failure(el) }
    bgImage.src = binding.value.image
  }
  bgMedium.src = binding.value.medium
})



// WEBPACK FOOTER //
// ./src/utils/directives.js